module.exports = {"data":{"site":{"siteMetadata":{"languages":{"defaultLangKey":"ru","langs":["en","ru"]}}}},"pathContext":{"slug":"/","langKey":"ru"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 896
// module chunks = 142629428675168